import React from 'react';
import ProgramsList from '../Programs/ProgramsList';

const Home = () => {
  return <ProgramsList />;
};

export default Home;
